import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';

import store from './store';

import {
	initCommon,
	BaseProviders,
	GameProviders,
} from '@remote-social/common';

// import the app
import App from './App';
import { appConfig } from './app-config';

initCommon();

const render = (Component) => {
	return ReactDOM.render(
		<BaseProviders store={store} appConfig={appConfig}>
			<GameProviders alwaysStartMuted={true}>
				<Component />
			</GameProviders>
		</BaseProviders>,
		document.getElementById('root'),
	);
};

render(App);

// add module hotswapping to reload modules in development mode
if (process.env.NODE_ENV !== 'production') {
	if (module.hot) {
		module.hot.accept('./App', () => {
			const NextApp = require('./App').default;
			render(NextApp);
		});
	}
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
